var map = {
	"./custom/app/header-nav-wrapper/header-navbar-wrapper.component": [
		72373,
		[
			"src_themes_custom_app_header-nav-wrapper_header-navbar-wrapper_component_ts"
		]
	],
	"./dspace/app/header-nav-wrapper/header-navbar-wrapper.component": [
		92161,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 20991;
module.exports = webpackAsyncContext;